
    import { Response } from "@/store/alarm-masking/types";
    import { Component, Vue, Prop, Emit } from "vue-property-decorator";
    import MaskingForm from "@/components/alarm-masking/MaskingForm.vue";
    import { namespace } from 'vuex-class';

    const AlarmMasking = namespace("alarmMasking");

	@Component({
        components: {
            "masking-form": MaskingForm
        }
	})

    export default class AdvancedMaskModal extends Vue {
        public $refs!: {
            maskingForm: MaskingForm
        }

        // Props
        @Prop({ type: Array, default(){ return [] }})
        public selectedResponses: Response[];

        @AlarmMasking.Getter getAreaMaskingMode: boolean;

        // Private Vars
        private isInvalid: boolean = true;

        // Getter Methods
        private get maskingTitle(): string {
            if (this.getAreaMaskingMode) {
                return "Mask Area";
            }
            else {
                return this.hasResponses ? "Mask Alarms" : "Mask Area Alarms";
            }
        }

        private get hasResponses(): boolean {
            return this.selectedResponses != null && this.selectedResponses.length != 0;
        }

        // Private Methods
        private async okMethod(): Promise<void> {
            return this.getAreaMaskingMode ? this.$refs.maskingForm.maskArea() : this.$refs.maskingForm.maskAlarms();
        }

        private validateMaskingForm(value: boolean): void {
            this.isInvalid = value;
        }

        // Emits
        @Emit("modalClosed")
        private close(): void {
            this.isInvalid = true;
        }
    }
